import { MenuType, PortalServiceMenuItemDtoPositionType } from '@nx-frontend/shared/types';

export function getPortalWizardUrl(domain: string, workspaceId: string, returnUrl = ''): string {
  const queryString = `mode=portal&workspace=${workspaceId}`;
  const backUrl = returnUrl ? returnUrl : window.location.href;
  return `${window.location.protocol}//${domain}/wizard?${queryString}&backUrl=${backUrl}`;
}

export function menuTypeToPositionType(menuType: MenuType | string): PortalServiceMenuItemDtoPositionType {
  return (
    (menuType.replace('portal-', '').replace('topbar', 'top') as PortalServiceMenuItemDtoPositionType) || 'sidebar'
  );
}

export function positionTypeToMenuType(positionType: PortalServiceMenuItemDtoPositionType | string): MenuType {
  return `portal-${positionType.replace('top', 'topbar')}` as MenuType;
}
